import { get } from '_helpers/api';

function getTariffs(countryCode, auth0Token) {
    return get({ path: 'tariffs', parameters: {countryCode} }, auth0Token);
}

export const tariffsService = {
    getTariffs,
}